import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18RetryB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M7.5 1.295a.614.614 0 0 0 .056.784l1.025 1.045-.171.012A6.86 6.86 0 0 0 4.883 4.48a7.13 7.13 0 0 0-2.797 4.67c-.6 3.898 2.016 7.565 5.828 8.177a7 7 0 0 0 1.09.088c3.418 0 6.373-2.553 6.91-6.039.398-2.573-.608-5.166-2.623-6.765a.563.563 0 0 0-.803.104.61.61 0 0 0 .102.845 6.02 6.02 0 0 1 2.186 5.627c-.5 3.242-3.498 5.468-6.686 4.96-3.184-.513-5.364-3.568-4.865-6.808a5.93 5.93 0 0 1 2.33-3.888l.21-.148a5.7 5.7 0 0 1 2.802-.981l.122-.007L7.556 5.47a.613.613 0 0 0 0 .852.565.565 0 0 0 .81 0l2.218-2.264a.41.41 0 0 0 .009-.558L8.365 1.227a.56.56 0 0 0-.809 0l-.057.068z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18RetryB$1 = Svg18RetryB;

export { Svg18RetryB$1 as default };
